import React from 'react'
import { GlobalStyle } from './GlobalStyles/GlobalStyle'
import { RequestInterceptor } from './Context/requestInterceptor'
import { SaveProvider } from './Context/saveContext'
import { RouteHandler } from './RouteHandler'

export const App = () => {
  return (
    <RequestInterceptor>
      <SaveProvider>
        <GlobalStyle />
        <RouteHandler />
      </SaveProvider>
    </RequestInterceptor>
  )
}
